<div class="surface-section px-4 py-5 md:px-6 lg:px-8 shadow-2 fixed-dashboard-bar transition-all" [ngClass]="{'hidden': isHidden}">
  <div class="flex flex-column md:align-items-center md:justify-content-between md:flex-row">
    <div class="flex align-items-center justify-content-center">
      <img src="assets/images/app_logo.png" alt="Logo" class="mr-2" style="height: 20px; vertical-align: middle" />
      <div class="font-medium text-3xl text-900">{{title}}</div>
    </div>
    <div class="flex justify-content-center mt-3 md:mt-0">
      <p-checkbox
        name="parent-view"
        [(ngModel)]="parentView"
        (onChange)="onParentViewCheckboxChange($event)"
        binary="true"
        label="Parent-View"></p-checkbox>
      <p-checkbox
        name="ecp-view"
        [(ngModel)]="ecpView"
        (onChange)="onECPViewCheckboxChange($event)"
        binary="true"
        label="ECP-View"
        class="ml-4 mr-4"></p-checkbox>
      <!--p-dropdown
        [options]="languages"
        [(ngModel)]="selectedLanguage"
        placeholder="Language"
        optionLabel="label"
        (onChange)="onLanguageChange($event)"
        class="mr-4">
        >
      </p-dropdown!-->
      <p-button label="Download" icon="pi pi-download" styleClass="p-button-primary" (onClick)="downloadPDFPressed.emit()"></p-button>
    </div>
  </div>
</div>
